import { ListboxOption } from '@microsoft/fast-foundation';
import { ChameleonElementMixin } from '../common/ChameleonElement';
import { SVG_CHECK } from '@getgo/chameleon-icons';
export class OptionComponent extends ChameleonElementMixin(ListboxOption) {
    selectedChanged() {
        super.selectedChanged();
        if (this.start) {
            if (this.selected) {
                this.start.innerHTML = `<chameleon-svg>${SVG_CHECK}</chameleon-svg>`;
            }
            else {
                this.start.innerHTML = '';
            }
        }
    }
}
